import { ReactElement } from 'react';
import VictimInformation from '@components/FVSPage/VictimInformation';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep6(): ReactElement {
  return (
    <>
      <VictimInformation displayObject={fvsInfoDisplayObject} currentStepNo="step6" />
      <br />
      <p>I understand that by providing contact details, Fines Victoria may update its records using these details and that I may be contacted regarding my outstanding fines.</p>
    </>
  );
}
export default FVSStep6;
